import React, { useEffect, useRef } from 'react';
import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';
import "../CSS/Styles/Typography.css";
import "../CSS/Styles/ColorTheme.css";
import "../CSS/Pages/LandingPage.css";
import "../CSS/Components/ExpandableBox.css";
import "../CSS/Components/CarouselBoxAlignLeft.css";

function CarouselAlignLeft() {
    const swiperRef = useRef(null);
    const carouselRef = useRef(null);

    useEffect(() => {
        const swiper = new Swiper(swiperRef.current, {
            // loop: true,
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
                dynamicBullets: true,
            },
            spaceBetween: 30, // Space between slides
            centeredSlides: true,
        });

        // Set up IntersectionObserver to detect when Swiper leaves view
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (!entry.isIntersecting) {
                    // When leaving the view, reset Swiper to the first slide
                    swiper.slideTo(0, 0); // Reset slide
                    swiper.update(); // Update swiper to ensure state consistency
                }
            },
            {
                root: null,
                threshold: 0.1, // Trigger when 10% is out of view
            }
        );

        const carouselElement = carouselRef.current;

        if (carouselElement) {
            observer.observe(carouselElement);
        }
  
        // Cleanup function to disconnect the observer
        return () => {
            if (carouselElement) {
                observer.unobserve(carouselElement);
            }
            swiper.destroy();
        };
    }, []);

    return (
        <div className="carousel-wrapper" ref={carouselRef}>
            <div className="swiper left" ref={swiperRef}>
                <div className="swiper-wrapper">
                    <div className="swiper-slide carousel-content primaryBody">
                        <div className='carousel-content'>
                            <p className="quote">
                                "We are not just making art, <span className="text-emphasis">we are creating an experience</span>"
                                <br/>
                                <div className="author fineBody black">
                                    <h2  style={{ marginTop: '0rem' }}>-CARLON ROSALES</h2>
                                </div>
                            </p>
                            <p className="secondaryBody" style={{ marginBottom: '1rem', marginTop: '0rem'}}>
                                <span className="text-emphasis">Our mission is to close the gap between bold vision and meaningful execution </span> 
                                helping brands turn what makes them distinct into experiences people can feel, remember, and believe in.
                                <br /><br />
                                {/* The exclusivity of <strong>greatness is a birthright of resilience!</strong> */}
                            </p>
                        </div>
                    </div>
                    <div className="swiper-slide carousel-content primaryBody">
                        <div className='carousel-content'>
                            
                            {/* <p className="secondaryBody" style={{ marginBottom: '1rem' }}>
                                Timing reflects your awareness of when to step in, when to guide, and when to let others shine. 
                                It is about precision, presence, and knowing that impactful creative direction is not accidental—it is orchestrated 

                            </p> */}
                            <p className="quote">
                                "Direction, is not just about how something looks, it is about <span className="text-emphasis">how a vision is built, guided, and experienced</span> from beginning to end"
                                <br/>
                                <div className="author fineBody black">
                                    <h2  style={{ marginTop: '0rem' }}>-Antané Phillips</h2>
                                </div>
                            </p>
                        </div>
                    </div>
                    <div className="swiper-slide carousel-content primaryBody">
                        <div className='carousel-content'>

                            <p className="secondaryBody" style={{ marginBottom: '0rem'}}>
                                We believe in the <span className="text-emphasis">power of collaboration</span> and are always open to partnering  
                                 <span className="text-emphasis"> with businesses and creatives</span> who share our vision of authenticity, cultural relevance, and intentional execution. <br/>
                                <br/>
                                Together, we <span className="text-emphasis">turn distinct ideas into cohesive experiences</span> that people can recognize, connect with, and remember!
                            </p>
                        </div>
                    </div>
                </div>
                <div className="swiper-pagination left-swpier"></div>
            </div>
        </div>
    );
}

export default CarouselAlignLeft;
